import getConfig from '@utils/getConfig';

import { PUBLIC_ENV_DEFAULTS_BY_APP_ENVIRONMENT, type PublicEnvKey } from './environmentDefaults';

/**
 * Non-empty runtime value from `/runtime-env.js`, else defaults for
 * `APP_ENVIRONMENT` (same URLs as `.env.${APP_ENVIRONMENT}` in this repo).
 */
function publicEnvValue(key: PublicEnvKey): string {
  const cfg = getConfig().publicRuntimeConfig;
  const direct = cfg[key];
  if (typeof direct === 'string' && direct.trim() !== '') {
    return direct;
  }
  const appEnv = cfg.APP_ENVIRONMENT;
  if (typeof appEnv !== 'string' || appEnv.trim() === '') {
    return '';
  }
  const fallback = PUBLIC_ENV_DEFAULTS_BY_APP_ENVIRONMENT[appEnv.trim()]?.[key] ?? '';
  return typeof fallback === 'string' ? fallback : '';
}

export const publicEnv = {
  get APP_ENVIRONMENT() {
    const v = getConfig().publicRuntimeConfig.APP_ENVIRONMENT;
    return typeof v === 'string' ? v : '';
  },
  get PNC_UI_APP_URL() {
    return publicEnvValue('PNC_UI_APP_URL');
  },
  get PNC_UI_WIDGET_URL() {
    return publicEnvValue('PNC_UI_WIDGET_URL');
  },
  get PNC_UI_API_URL_API_GATEWAY() {
    return publicEnvValue('PNC_UI_API_URL_API_GATEWAY');
  }
};
